import { environment } from '../../../environments/environment';

export class AppUrlConstants {
  public static host = environment.apiHost;
  public static emailHost = environment.emailHost;
  public static internalChatbotHost = 'https://drl.cogentcore.ai/pgml3';
  public static internalDashboardHost = 'https://drl.cogentcore.ai/pgml3';
  public static api = "/api";
  public static v1 = "/v1";
  public static auth = "/auth";
  public static user = "/user";
  public static LIST = "/list";
  public static ADD = "/add";
  public static EDIT = "/edit";
  public static UPDATE = "/update";
  public static DELETE = "/delete";
  public static SEARCH = "/search";
  public static COMPLAINT = "/complaint";
  public static COMPLAINT_PROCESS = "/complaint-process";
  public static SEGMENT = "/segment";
  public static FRAME = "/frame";
  public static GROUP = "/group";
  public static TYPE = "/type";
  public static LOGOUT = "/logout";
  public static NOTIFICATION = "/notification";
  public static GET_BY_TYPE = "/getByType";
  public static GET_DIVISION = "/getDivision";
  public static COMPLAINT_CATEGORY = "/complaint-category";
  public static ADMINISTRATIVE_STRUCTURE = "/administrative-structure";
  public static PARENT_CATEGORY = "/parent-category";
  public static COMPLAINT_SUB_CATEGORY = "/complaint-subcategory";
  public static BY_PARETN_ID = "/getByParentId";
  public static ADD_USERS = "/add-users";
  public static PERMISSION = "/permission";
  public static AUTHENTICATE = "/authenticate";
  public static REGISTER = "/register";
  public static ADMIN_STRUCTURE_BY_PARENT_IDS = "/adminstructure-by-parent/ids";
  public static ADMIN_STRUCTURE_BY_IDS = "/adminstructureby/ids";
  public static TRACKING = "/tracking";
  public static DOCUMENT = "/document";
  public static DOCUMENT_DOWNLOAD = "/document/download";
  public static DASHBOARD = "/dashboard";
  public static COMPLAINT_BY_STATUS_COUNT = "/complaint/by/status/count";
  public static COMPLAINT_BY_CATEGORY_COUNT = "/complaint/by/category/count";
  public static COMPLAINT_BY_DIVISION_AND_STATUS_COUNT =
    "/complaint/by/division/status/count";
  public static COMPLAINT_BY_DIVISION_COUNT = "/complaint/by/division/count";
  public static COMPLAINT_BY_MONTH_COUNT = "/complaint/by/month/count";
  public static USERS_INTERNAL = "/internal/list";
  public static ACTIVE_INACTIVE_USERS_INTERNAL_LIST = "/internal/all/list";
  public static SEND_EMAIL = "/send/email";
  public static SEND_SMS = "/send/sms";
  public static COMPLAINT_BY_SUBCATEGORY_COUNT =
    "/complaint/by/subcategory/count";
  public static COMPLAINT_BY_DISTRICT_COUNT = "/complaint/by/district/count/";
  public static COMPLAINT_BY_TEHSIL_COUNT = "/complaint/by/tehsil/count/";
  public static COMPLAINT_BY_mouza_COUNT = "/complaint/by/mouza/count/";
  public static COMPLAINT_BY_AGENT_ALL_COUNT = "/complaint/by/agentall/count";
  public static COMPLAINT_BY_AGENT_COUNT = "/complaint/by/agent/count";
  public static COMPLAINT_BY_AGENT_ALL_DETAIL_COUNT =
    "/complaint/by/agentalldetail/count";
  public static COMPLAINT_BY_AGENT_DETAIL_COUNT =
    "/complaint/by/agentdetail/count";
  public static COMPLAINT_BY_STATUS_AND_GENDER_COUNT =
    "/complaint/by/statusandgender/count";
  public static COMPLAINT_BY_TOTAL_STATUS_AND_GENDER_COUNT =
    "/complaint/by/totalstatusandgender/count";
  public static COMPLAINT_BY_USER_STATUS_COUNT =
    "/complaint/by/user/status/count";
  public static COMPLAINT_BY_COMPLAINT_SUMMARY_COUNT =
    "/complaint/by/complaintSummary/count";
  public static COMPLAINT_BY_CATEGORY_AND_SUBCAREGORY_COUNT =
    "/complaint/by/categoryandsubcategory/count";
  public static COMPLAINT_DELAY_AGING_LIST =
    "/complaint/delay/aging/list";
  public static COMPLAINT_DELAY_CATEGORY_WISE =
    "/complaint/delay/category/wise";
  public static COMPLAINT_DELAY_USER_WISE =
    "/complaint/delay/user/wise";
  public static USERS_BYREGION = "/byregion/list";
  public static GROUP_BYREGION = "/byregion/list";
  public static PUBLIC = "/public";
  public static DROP = "/drop";
  public static APPEAL = "/appeal";
  public static CHANGE_PASSOWRD = "/changePassword";
  public static FIND_BY_USER_NAME = "/findByUserName";
  public static CHANGE_PROFILE = "/changeProfile";
  public static USER_PERMISSIONS = "/get/user/permissions";
  public static FORGET_PASSWORD = "/forgetPassword";
  public static SAVE_NEW_PASSWORD = "/saveNewPassword";
  public static PUBLISH_DOCUMENT = "/publishdocument";
  public static VERIFY_OTP = "/verify-otp";
  public static RETRY_OTP = "/retry-otp";
  public static NOTIFICATION_MESSAGE_BY_USER = "/notification-message/by/user";
  public static NOTIFICATION_MESSAGE_READ_BY_ID = "/notification-message/read";
  public static SMS_TRACKING = "/sms-tracking";
  public static SMS_TRACKING_COUNT = "/count";
  public static SMS_TRACKING_DETAILS = "/details";
  public static CHAT_ENDPOINT = "/chat";
  public static FAILED = "/failed";
  public static QUERIES = "/queries";
  public static CHAT_LOGS = "/chatLogs";
  public static APPROVE = "/approve";
  public static GET_PERSONAL_INFO = "/getPersonal/info";
  public static WHATSAPP = "/whatsapp";
  public static CONVERSATION = "/conversation";
  public static SUMMARY = "/summary";
  public static CHATBOT_ASSIST = "/chatbot/assist";
  public static EMAILS = "/emails";
  public static BLACKLISTED = "/blacklisted";
  public static GREYLISTED = "/greylisted";
  public static WHITELISTED = "/whitelisted";
  public static CHATBOT = "/chatbot";
  public static BULK_UPLOAD = "/bulk-upload";
  public static CHAT_SUGGESTION = '/chat/getSuggestion';
  public static CHAT_BOT = "/chat/getAnswer";
  public static COMPLAINT_STATUS_CHECK = '/chat/Otpfor/Status';
  public static COMPLAINT_OTP_VERIFY = '/chat/Otpfor/Verify';


  public static AUth_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.auth +
    AppUrlConstants.AUTHENTICATE;
  public static USER_PERMISSION_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.auth +
    AppUrlConstants.USER_PERMISSIONS;
  public static LOGOUT_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.auth +
    AppUrlConstants.LOGOUT;
  public static USER_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.user;
  public static COMPLAINT_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.COMPLAINT;
  public static ADMINISTRATIVE_STRUCTURE_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.ADMINISTRATIVE_STRUCTURE;
  public static COMPLAINT_PROCESS_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.COMPLAINT_PROCESS;
  public static SEGMENT_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.SEGMENT;
  public static COMPLAINT_CATEGORY_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.COMPLAINT_CATEGORY;
  public static COMPLAINT_SUB_CATEGORY_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.COMPLAINT_CATEGORY +
    AppUrlConstants.COMPLAINT_SUB_CATEGORY;

  public static GROUP_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.GROUP;
  public static PERMISSION_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.PERMISSION;
  public static FRAME_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.FRAME;
  public static DASHBOARD_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.DASHBOARD;
  public static NOTIFICATION_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.NOTIFICATION;
  public static PUBLIC_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.PUBLIC;
  public static CHANGE_PASSOWRD_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.auth +
    AppUrlConstants.CHANGE_PASSOWRD;
  public static USER_FIND_BY_USER_NAME =
    AppUrlConstants.USER_URL + AppUrlConstants.FIND_BY_USER_NAME;
  public static FORGET_PASSWORD_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.auth +
    AppUrlConstants.FORGET_PASSWORD;
  public static SAVE_NEW_PASSWORD_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.auth +
    AppUrlConstants.SAVE_NEW_PASSWORD;
  public static PUBLISH_DOCUMENT_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.COMPLAINT +
    AppUrlConstants.PUBLISH_DOCUMENT;
  public static DOCUMENT_DELETE_URL = AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.COMPLAINT +
    AppUrlConstants.DOCUMENT;
  public static DROP_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.COMPLAINT +
    AppUrlConstants.DROP;
  public static APPEAL_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.COMPLAINT +
    AppUrlConstants.APPEAL;
  public static AUTH_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.auth;

  public static GET_NOTIFICATION_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.NOTIFICATION_MESSAGE_BY_USER;

  public static MARK_NOTIFICATION_URL =
    AppUrlConstants.api +
    AppUrlConstants.v1 +
    AppUrlConstants.NOTIFICATION_MESSAGE_READ_BY_ID;

  public static SMS_TRACKING_URL =
    AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.SMS_TRACKING;


  public static GET_QUERIES = AppUrlConstants.host + AppUrlConstants.api +
    AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.QUERIES;

  public static ADD_NEW_QUERY = AppUrlConstants.host + AppUrlConstants.api +
    AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.QUERIES + AppUrlConstants.ADD;

  public static UPDATE_QUERY = AppUrlConstants.host + AppUrlConstants.api +
    AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.QUERIES + AppUrlConstants.UPDATE;

  public static DELETE_QUERY = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT
    + AppUrlConstants.QUERIES;





  public static GET_FAILED_QUERIES = AppUrlConstants.host + AppUrlConstants.api +
    AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.FAILED;

  public static UPDATE_FAILED_QUERIES = AppUrlConstants.host + AppUrlConstants.api +
    AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.FAILED + AppUrlConstants.APPROVE;

  public static DELETE_FAILED_QUERIES = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT +
    AppUrlConstants.FAILED;


  public static GET_CHATLOGS = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT +
    AppUrlConstants.CHAT_LOGS;

  public static DELETE_CHATLOGS = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT +
    AppUrlConstants.GET_CHATLOGS;

  public static GET_PERSONAL_INFO_URL =  AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.COMPLAINT+ AppUrlConstants.GET_PERSONAL_INFO;

  public static WHATSAPP_SUMMARY = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.WHATSAPP + AppUrlConstants.SUMMARY;
  
  public static WHATSAPP_CONVERSATION = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.WHATSAPP + AppUrlConstants.CONVERSATION;

  public static WHATSAPP_AI_AGENT_SUMMARY = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.WHATSAPP + "/ai-agent" + AppUrlConstants.SUMMARY;

  public static WHATSAPP_AI_AGENT_CONVERSATION = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.WHATSAPP + "/ai-agent" + AppUrlConstants.CONVERSATION;

  public static WHATSAPP_AI_AGENT_AUDIO = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.WHATSAPP + "/ai-agent/audio";
  
  public static CHATBOT_ASSIST_ADD = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.CHATBOT_ASSIST + AppUrlConstants.ADD;
  public static CHATBOT_ASSIST_LIST = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.CHATBOT_ASSIST + AppUrlConstants.LIST;

  public static BLACKLISTED_EMAILS_URL = AppUrlConstants.emailHost + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.EMAILS + AppUrlConstants.BLACKLISTED;
  public static GREYLISTED_EMAILS_URL = AppUrlConstants.emailHost + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.EMAILS + AppUrlConstants.GREYLISTED;
  public static WHITELISTED_EMAILS_URL = AppUrlConstants.emailHost + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.EMAILS + AppUrlConstants.WHITELISTED;

  // Email thread: append /{draftId}/thread at call site
  public static EMAIL_BASE_URL = AppUrlConstants.emailHost + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.EMAILS;
  // Email draft detail: append ?intakeId={id} at call site
  public static EMAIL_DRAFT_URL = AppUrlConstants.EMAIL_BASE_URL + '/draft';
  public static EMAIL_COUNTS_URL = AppUrlConstants.EMAIL_BASE_URL + '/counts';
  public static ALL_EMAILS_URL = AppUrlConstants.EMAIL_BASE_URL + '/all';

  // Analytics Metadata Management (PGML)
  public static ANALYTICS_METRIC_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/analytics/metrics';
  public static ANALYTICS_DIMENSION_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/analytics/dimensions';
  public static ANALYTICS_FILTER_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/analytics/filters';
  public static ANALYTICS_WIDGET_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/analytics/widgets';
  public static ANALYTICS_MAPPING_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/analytics/mappings';
  public static ANALYTICS_DASHBOARD_ASK_URL = AppUrlConstants.internalDashboardHost + AppUrlConstants.api + AppUrlConstants.v1 + '/analytics/dashboard/ask';

  // Internal Chatbot (PGML)
  public static INTERNAL_CHAT_ASK_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/internal/chat/ask';
  public static INTERNAL_CHAT_APPLICATIONS_URL = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + '/internal-chat/applications';
  public static INTERNAL_CHAT_MESSAGES_URL = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + '/internal-chat/messages';
  public static INTERNAL_CHAT_LOGS_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/internal/chat/logs';
  public static INTERNAL_DOCUMENTS_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/documents';
  public static INTERNAL_DOCUMENT_UPLOAD_URL = AppUrlConstants.INTERNAL_DOCUMENTS_URL + '/upload';
  public static INTERNAL_TRAINING_HISTORY_URL = AppUrlConstants.internalChatbotHost + AppUrlConstants.api + AppUrlConstants.v1 + '/internal/training-history';

  // Citizen Chatbot async training pipeline
  public static TRAINING_DATA = '/training-data';
  public static TRAINING_HISTORY = '/training-history';
  public static ADD_TRAINING_DATA = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.TRAINING_DATA;
  public static GET_TRAINING_HISTORY = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + AppUrlConstants.TRAINING_HISTORY;
  public static WEBSITE_CRAWLS = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + '/website-crawls';
  public static WEBSITE_KNOWLEDGE_CRAWL_IMPORT = AppUrlConstants.host + AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.CHAT_ENDPOINT + '/website-knowledge/crawls';

  // Citizen Chatbot OTP flow
  public static COMPLAINT_STATUS_CHECK_URL = AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.COMPLAINT_STATUS_CHECK;
  public static COMPLAINT_OTP_VERIFY_URL = AppUrlConstants.api + AppUrlConstants.v1 + AppUrlConstants.COMPLAINT_OTP_VERIFY;
}
